import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Question, Rfp, RfpCreateDto, RfpSummaryDto } from 'src/app/domain/rfp.model';

@Injectable({
  providedIn: 'root'
})
export class RfpService {
  private RFP_PATH = "/appliances/api/v2/rfp-requests";
  private CUSTOMER_PATH = "/appliances/api/v2/customers";
  private USER_PATH = "/appliances/api/v2/user";
  constructor(private http: HttpClient) { }

  getRfps(): Observable<Rfp[]> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.get<Rfp[]>(this.RFP_PATH, { headers });
  }

  addRfp(rfpData: RfpCreateDto): Observable<Rfp> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post<Rfp>(this.RFP_PATH, rfpData, { headers });
  }

  getCustomers(): Observable<any[]> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.get<any[]>(this.CUSTOMER_PATH, { headers });
  }

  getTechLeads(): Observable<any[]> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.get<any[]>(`${this.USER_PATH}/tech-leads`, { headers });
  }

  getRfpById(id: number): Observable<Rfp> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.get<Rfp>(`${this.RFP_PATH}/${id}`, { headers });
  }
  updateRfp(id: number, rfpData: RfpCreateDto): Observable<Rfp> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.put<Rfp>(`${this.RFP_PATH}/${id}`, rfpData, { headers });
  }

  //deleteRfp by id

  deleteRfp(id: number): Observable<any> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.delete<any>(`${this.RFP_PATH}/${id}`, { headers });
  }

  getRfpSummary(): Observable<RfpSummaryDto[]> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.get<RfpSummaryDto[]>(`${this.RFP_PATH}/summary`, { headers });
  }

  getQuestions(): Observable<Question[]> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.get<Question[]>(`${this.RFP_PATH}/questions`, { headers });
  }
  
}
